import { environment } from '@environment/environment';
import { BP_DRAWER_DEFAULTS, BpDrawerOptions } from './bp-drawer-ref';

/** Clave de `localStorage` donde la página de pruebas guarda sus ajustes. */
export const BP_DRAWER_PLAYGROUND_STORAGE_KEY = 'bp-drawer-playground';

/** Lo que guarda la página de pruebas del drawer (`/drawer-playground`). */
export interface BpDrawerPlaygroundSettings {
  /** Aplicar los ajustes también a los drawers reales del portal (p. ej. «Detalle del movimiento»). */
  applyToAll: boolean;
  options: Partial<BpDrawerOptions>;
}

/** La página de pruebas solo existe fuera de producción (local y dev). */
export const BP_DRAWER_PLAYGROUND_ENABLED = !environment.production;

export function readBpDrawerPlaygroundSettings(): BpDrawerPlaygroundSettings | null {
  if (!BP_DRAWER_PLAYGROUND_ENABLED) {
    return null;
  }
  try {
    const raw = localStorage.getItem(BP_DRAWER_PLAYGROUND_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as BpDrawerPlaygroundSettings) : null;
  } catch {
    return null;
  }
}

export function writeBpDrawerPlaygroundSettings(settings: BpDrawerPlaygroundSettings): void {
  if (!BP_DRAWER_PLAYGROUND_ENABLED) {
    return;
  }
  localStorage.setItem(BP_DRAWER_PLAYGROUND_STORAGE_KEY, JSON.stringify(settings));
}

/**
 * Ajustes que pisan a los de cada drawer real, si en la página de pruebas se pidió aplicarlos.
 * Solo los que se cambiaron respecto del valor por defecto: así un drawer que pide algo propio
 * (p. ej. no cerrarse al tocar fuera) lo conserva mientras la página de pruebas no lo toque.
 */
export function readBpDrawerOverrides(): Partial<BpDrawerOptions> {
  const settings = readBpDrawerPlaygroundSettings();
  if (!settings?.applyToAll) {
    return {};
  }
  const changed = Object.entries(settings.options).filter(
    ([key, value]) =>
      JSON.stringify(value) !== JSON.stringify(BP_DRAWER_DEFAULTS[key as keyof BpDrawerOptions]),
  );
  return Object.fromEntries(changed) as Partial<BpDrawerOptions>;
}
